import React from 'react';
import styled from 'styled-components';
import { Flex } from './Flex';
import { Icon } from './Icon';
import { PageHeader } from './PageHeader';
import { observer } from 'mobx-react-lite';

const StyledBody = styled.div`
  margin: 0px;
  padding: 20px;
`;

interface Props {
  title: string;
  children: any;
}

export const Attention = observer((props: Props) => {
  const { title, children } = props;
  return (
    <Flex center>
      <StyledBody>
        <PageHeader>
          <Icon name="i-rms-info" /> {title}
        </PageHeader>
        {children}
      </StyledBody>
    </Flex>
  );
});
